import { Bouton } from "@/composants/ui/bouton";

/**
 * Le pied d'une liste paginée : ce qu'on voit, ce qu'il reste, et de quoi en voir plus.
 *
 * Il dit toujours le compte, même quand tout tient sur une page. Une liste qui
 * n'annonce rien laisse le lecteur supposer qu'il a tout — et c'est précisément
 * ce que la pagination corrige : au-delà de cinquante lignes, l'écran
 * s'arrêtait sans le dire.
 */
export function PiedDeListe({
  affiches,
  total,
  reste,
  enCours,
  onCharger,
  nom,
}: {
  affiches: number;
  total: number;
  reste: number;
  enCours: boolean;
  onCharger: () => void;
  /** Au singulier : « dossier », « lot », « client ». */
  nom: string;
}) {
  if (total === 0) return null;
  const pluriel = total > 1 ? "s" : "";
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-filet px-4 py-3">
      <p className="text-sm text-encre-douce" role="status">
        {reste > 0 ? (
          <>
            <span className="tabular-nums">{affiches}</span> {nom}
            {pluriel} affiché{pluriel} sur <span className="tabular-nums">{total}</span>
          </>
        ) : (
          <>
            <span className="tabular-nums">{total}</span> {nom}
            {pluriel}
          </>
        )}
      </p>
      {reste > 0 ? (
        <Bouton taille="compact" onClick={onCharger} disabled={enCours}>
          {enCours ? "Chargement…" : `Afficher les ${Math.min(reste, 50)} suivants`}
        </Bouton>
      ) : null}
    </div>
  );
}
